import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  BookingPageQuestionsAnswerTypeEnum,
  CfSchemaMeetingInfo,
  SchemaMeetingTemplateQuestion,
} from '@cf/temp/services';
import { TranslateService } from '@tolgee/ngx';
import {
  OTHER_ANSWER_ID,
  getAnswerFieldValidators,
  getAnswerTextFieldValidators,
  getAnswersFieldValidators,
} from '../../const';
import { IBookingForm } from '../../interfaces';
import { QuestionFieldComponent } from './components/booking-question-field/booking-question-field.component';

@Component({
  selector: 'cf-booking-questions',
  imports: [FormsModule, ReactiveFormsModule, QuestionFieldComponent],
  templateUrl: './booking-questions.component.html',
  styleUrl: './booking-questions.component.scss',
})
export class BookingQuestionsComponent implements OnInit, OnDestroy {
  form = input<FormGroup<IBookingForm>>();
  booking = input<CfSchemaMeetingInfo>();
  isPreview = input<boolean>();

  fb = inject(FormBuilder);
  translateService = inject(TranslateService);

  get questionsControls(): FormArray<FormGroup> {
    return this.form()!.controls.questions;
  }

  ngOnInit() {
    this.booking()!.questions = this.booking()!.questions!.filter((question) => !question.disabled);
    this.booking()!.questions!.forEach((question) => {
      if (
        question.include_other_option &&
        question.answer_type === BookingPageQuestionsAnswerTypeEnum.dropdown
      ) {
        question.answers = [
          ...(question.answers ?? []),
          {
            id: OTHER_ANSWER_ID,
            index: Math.max(...(question.answers?.map((a) => a.index) ?? [0])) + 1,
            answer: this.translateService.instant('other'),
          },
        ];
      }

      this.questionsControls.push(this.createQuestionFormGroup(question));
    });
  }

  ngOnDestroy() {
    this.questionsControls.clear();
  }

  private createQuestionFormGroup(question: SchemaMeetingTemplateQuestion): FormGroup {
    return this.fb.group({
      question: [question.id],
      answer: [null, getAnswerFieldValidators(question)],
      answers: [[], getAnswersFieldValidators(question)],
      is_other_option: [false],
      answer_text: ['', getAnswerTextFieldValidators(question)],
    });
  }
}
